'use strict';

const helper = require('../../helper');
const loaderInstance = require('../../loaderHelper');
const venmoHelper = require('../helpers/venmoHelper');
const VenmoAlertHandlerModel = require('../alertHandler/venmoAlertHandlerModel');
const alertHandler = new VenmoAlertHandlerModel();

const $venmoButton = document.querySelector('.js-braintree-account-venmo-button');

let venmoLoader;

/**
 * Makes Venmo account as default one
 * @param {Event} e event to identify target element
 */
function makeDefaultVenmo(e) {
    const target = e.target;
    const url = window.braintreeUrls.makePaymentMethodDefaultUrl;
    const id = target.getAttribute('data-id');
    const paymentMethodID = window.braintreePreferences.paymentMethods.BRAINTREE_VENMO.paymentMethodId;
    const loaderContainerEl = document.getElementById(target.getAttribute('data-loader'));
    const loader = loaderInstance(loaderContainerEl);

    alertHandler.hideAlerts();
    loader.show();

    helper.setDefaultProperty({
        url: url,
        id: id,
        paymentMethodID: paymentMethodID,
        loader: loader
    });
}

/**
 * Inits Venmo account element listeners such as enabling a make default or remove account functionality
 */
function initVenmoAccountElListeners() {
    // "Make default" button functionality initiation
    document.querySelectorAll('.js-venmo-accounts .js-braintree-make-default-card')
        .forEach((el) => el.addEventListener('click', makeDefaultVenmo));
    // "Remove" button functionality initiation
    document.querySelectorAll('.js-venmo-accounts .js-remove-bt-payment')
        .forEach((el) => el.addEventListener('click', helper.removeBtPayment));
}

/**
 * Creates Venmo form data on account page
 * @param {Object} payload Payload details from Venmo
 * @returns {Object} object with Venmo form data
 */
function createVenmoAccountFormData(payload) {
    const venmoAccountFormFields = $venmoButton.getAttribute('data-venmo-account-form-fields');
    const csrfToken = document.querySelector('.js-braintree-account-venmo-button-wrapper #csrf_token');
    const payerInfo = payload.details.payerInfo;
    const billingAddress = venmoHelper.createBillingAddress(payerInfo);

    const venmoAccountFormData = helper.createPaymentFormData(venmoAccountFormFields, {
        nonce: payload.nonce,
        userId: payload.details.username,
        billingAddress: JSON.stringify(billingAddress)
    });

    venmoAccountFormData.append(csrfToken.name, csrfToken.value);

    return venmoAccountFormData;
}

/**
 * Stores new Venmo account
 * @param {Object} data tokenized payload data with Venmo nonce
 * @returns {Promise} call to Braintree-AccountAddVenmoHandle endpoint
 */
function storeNewVenmoAccount(data) {
    const venmoAddAccountHandlerUrl = $venmoButton.getAttribute('data-venmo-add-account-handler');
    const venmoAccountFormData = createVenmoAccountFormData(data);
    const encodedFormData = btoa(JSON.stringify(Object.fromEntries(venmoAccountFormData)));

    venmoLoader.show();

    return fetch(helper.getUrlWithCsrfToken(venmoAddAccountHandlerUrl), {
        method: 'POST',
        body: encodedFormData,
        headers: { 'Content-Type': 'application/json' }
    })
        .then((response) => response.json())
        .then((paymentData) => {
            venmoLoader.hide();
            if (paymentData.error) {
                alertHandler.showError(paymentData.error);
            } else {
                venmoHelper.hideVenmoAccountBtn();
                fetch(paymentData.renderAccountsUrl)
                    .then((template) => template.text())
                    .then((templateHTML => {
                        document.querySelector('.js-venmo-accounts').innerHTML = templateHTML;
                        initVenmoAccountElListeners();
                    }));
            }
        });
}

/**
 * Inits Venmo functionality
 */
function init() {
    const braintreeVenmoLoaderEl = document.getElementById('braintreeVenmoAccLoader');
    const venmoAccountCardEl = document.querySelector('.js-venmo-card');
    const addVenmoAccountButtonEl = document.querySelector('.js-add-venmo-account');

    if (braintreeVenmoLoaderEl) {
        venmoLoader = loaderInstance(braintreeVenmoLoaderEl);
    }

    venmoAccountCardEl.classList.remove('d-none');
    initVenmoAccountElListeners();

    addVenmoAccountButtonEl?.addEventListener('click', async function() {
        if (!window.venmoAccountButtonInitted) {
            window.venmoAccountButtonInitted = true;

            const VenmoBase = require('../models/venmoBase');
            const venmoBaseInstance = new VenmoBase();

            await venmoBaseInstance.initButton();
        }

        // Hide venmo account error container
        alertHandler.hideAlerts();
        venmoHelper.showVenmoAccountBtn();
    });
}

module.exports = {
    init,
    storeNewVenmoAccount
};
